export const requirementsOptions: {id: string; name: string}[] = [
  { id: 'all', name: 'All users' },
  { id: 'individual', name: 'Only for Individual' },
  { id: 'company', name: 'Only for Company' },
];
